import React from 'react';
import './spinner.css'

export default function Spinner() {
    return (
        <div className='spinner-div'><span className="spinner"></span></div>
    );
}